import type { InCenterTeamingNoticeSnapshot } from 'features/app/store/app/interfaces/inCenterTeamingNoticeSnapshot';
import type { RootState } from 'features/app/store/store';
import { TeamingType } from 'features/teaming/teaming-base/enums';

export const getInCenterTeamingNoticeSnapshot = (
  state: RootState
): InCenterTeamingNoticeSnapshot | null => {
  if (state.teaming.teamingType !== TeamingType.InCenterAnyRequest) {
    return null;
  }

  return {
    reason: state.teaming.reason,
    languageCode: state.call.languageCode,
    genderRequest: state.call.genderRequest,
    station: state.teaming.station,
  };
};
